export default {"src":"/_next/static/media/dew.dd20d477.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};